export default (api, resource) => ({

    getAll: async({token,params}) =>{

        const response = await api.get(resource,{
            params,
            headers:{ 
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    },

    create: async({establishments,token}) =>{
        const response = await api.post(resource,establishments,{
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    },


    update: async({establishments,token}) =>{
        const response = await api.put(`${resource}/${establishments.id}`,establishments,{
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    },

    // Bloqueio do ponto: derruba TV, POS e cobrador. Motivo obrigatorio.
    bloquear: async({id, motivo, token}) =>{
        const response = await api.put(`${resource}/${id}/bloquear`, { motivo }, {
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    },

    desbloquear: async({id, token}) =>{
        const response = await api.put(`${resource}/${id}/desbloquear`, {}, {
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    },

    /*
      Instalacoes do app da TV registradas no ponto.

      Lista vazia nao significa "sem TV": aparelhos que ainda nao foram
      atualizados nao se identificam e nao geram registro -- sao os "Legado".
    */
    getInstalacoes: async({id, token}) =>{
        const response = await api.get(`${resource}/${id}/instalacoes`, {
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    },

    revogarInstalacao: async({instalacaoId, token}) =>{
        const response = await api.put(`${resource}/instalacao/${instalacaoId}/revogar`, {}, {
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    },

    aprovarInstalacao: async({instalacaoId, token}) =>{
        const response = await api.put(`${resource}/instalacao/${instalacaoId}/aprovar`, {}, {
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data
        }
    }
})